"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerGameAggregateSchema = exports.MultiPlayerAggregateSchema = exports.PlayerSequenceAggregateSchema = void 0;
const zod_1 = require("zod");
const player_1 = require("./player");
const aggregate_1 = require("./aggregate");
const game_1 = require("./game");
exports.PlayerSequenceAggregateSchema = zod_1.z.object({
    game_id: zod_1.z.number(),
    team_id: zod_1.z.number(),
    competition_id: zod_1.z.number(),
    season_id: zod_1.z.number(),
    cycle_id: zod_1.z.number(),
    position: zod_1.z.string(),
    game_date: zod_1.z.string(),
});
exports.MultiPlayerAggregateSchema = zod_1.z.object({
    player: player_1.PlayerSchema,
    aggregates: aggregate_1.AggregateSchema,
});
exports.PlayerGameAggregateSchema = game_1.GameWithRelsSchema.extend({
    aggregates: aggregate_1.AggregateSchema,
});
//# sourceMappingURL=playerAggregate.js.map